import ADIColors from "@NA/Utils/ADIColors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";
interface OwnProps {
    product: ProductModel;
    extendedStyles?: ADIProductDescriptionStyles;
}
type Props = OwnProps;
export interface ADIProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}
export const adiProductDescriptionStyles: ADIProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            color: "text.main",
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
                display: -webkit-box;
                line-clamp: 2;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                color: ${ADIColors.black} !important;
                font-weight: 600;
                &:hover {
                    color: ${ADIColors.blue1} !important;
                    text-decoration: underline;
                }
            `,
        },
    },
    productDetailDescription: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            line-height: normal;
            text-align: left;
            color: ${getColor("text.main")} !important;
            overflow-wrap: break-word;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-word;
            min-height: 60px;
            width: 100%;
            margin-left: 15px;
        `,
    },
};
const ADIProductDescription: FC<Props> = ({ product, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(adiProductDescriptionStyles, extendedStyles));
    const description = product.productTitle ? product.productTitle : product.shortDescription;
    const productDetailPath = product.productDetailUrl;
    return <Typography {...styles.productDetailDescription}>{description}</Typography>;
};
export default ADIProductDescription;
